<template>
  <div
    v-if="isOffline"
    class="offline-indicator"
  >
    <div class="wrapper">
      <p
        class="offline-indicator__text"
      >
        {{ $t('You are offline, the data shown can be outdated.') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfflineIndicator',
};
</script>

<style scoped lang="scss">
  .offline-indicator {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: $color-error;
    width: 100%;
    color: $white;
    z-index: 2;
    padding: 1.1rem 1rem;
    display: flex;
    align-items: center;
    &__text {
      margin: 0;
    }
  }
</style>
